import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;
const LOCAL_URL = "http://localhost:8080/"

export const publicAxiosInstance = axios.create({
  baseURL: `${BASE_URL}`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const publicAxiosLocalInstance = axios.create({
  baseURL: `${LOCAL_URL}`,
  headers: {
    "Content-Type": "application/json",
  },
});